import Form from '../../../../components/form';
import request from '../../../../utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'arrival_time_form',
      formParentCode: 'CRM20210105000000416',
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'exchangeArrivalTime') {
        v.props = {
          ...v.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          defaultTime: '00:00:00',
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {},
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/mdm/mdmexchangeapply/saveExchangeArrivalTime';
        const params = {
          exchangeArrivalTime: formData.exchangeArrivalTime,
          id: this.formConfig.businessId,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
